// IMOTEpS — Centre de recherche / Chapitre 6
// Auto-split from chapters.js (Feb 2026 refactor)

export const chapter06 = {
  id: 6,
  slug: "instabilite-epaule",
  color: "#2E7D6B",
  title: "Instabilité gléno-humérale",
  subtitle: "Lésions de Bankart, Hill-Sachs, glenoid track et Latarjet",
  region: "Épaule",
  readingMin: 16,
  summary:
    "Classification de l'instabilité (antérieure, postérieure, multidirectionnelle), lésions associées (Bankart osseux, Hill-Sachs, SLAP), examen (appréhension, relocation), arthro-IRM et scanner 3D, indications du Latarjet vs Bankart arthroscopique selon la règle des 20-25 % de perte osseuse glénoïdienne (glenoid track).",
  sections: [
    {
      heading: "1. Classification clinique",
      body: "L'instabilité antérieure post-traumatique (TUBS) reste la plus fréquente, particulièrement chez le sujet jeune sportif. L'instabilité postérieure (rare, souvent volontaire) et l'instabilité multidirectionnelle (AMBRI, terrain hyperlaxe) nécessitent une approche différente.",
    },
    {
      heading: "2. Lésions anatomiques associées",
      list: [
        "Lésion de Bankart : avulsion du labrum antéro-inférieur (cartilagineuse ou osseuse)",
        "Encoche de Hill-Sachs : impaction de la tête humérale sur la glène",
        "Lésion ALPSA : Bankart cicatrisé en position médialisée",
        "Lésion SLAP : décollement du labrum supérieur",
        "Lésion HAGL : avulsion humérale du ligament gléno-huméral inférieur",
      ],
    },
    {
      heading: "3. Examen clinique",
      body: "Le test d'appréhension (bras en abduction-rotation externe forcée) et le test de relocation de Jobe (douleur abolie par rétropulsion humérale) sont les plus spécifiques. Le test de load-and-shift quantifie le glissement antérieur ou postérieur.",
    },
    {
      heading: "4. Imagerie quantifiée",
      body: "Le scanner avec reconstruction 3D et soustraction de la tête humérale permet la mesure précise de la perte osseuse glénoïdienne. La règle du glenoid track (Yamamoto/Itoi) considère la lésion 'off-track' lorsque la distance de Hill-Sachs dépasse 83 % de la largeur de la glène intacte.",
    },
    {
      heading: "5. Indications chirurgicales",
      body: "En dessous de 20 % de perte osseuse, le Bankart arthroscopique avec 3 à 4 ancres reste l'option de référence. Au-delà, et systématiquement chez le sportif de contact, la butée coracoïdienne de Latarjet (effet sling + butée + plastie capsulaire) offre les meilleurs taux de stabilité à long terme (récidives < 5 %).",
    },
    {
      heading: "6. Reprise du sport",
      body: "Sports sans contact : 3 mois après Bankart arthroscopique, 4 mois après Latarjet. Sports de contact (rugby, judo, MMA) : feu vert à 4 mois post-Latarjet, 6 mois post-Bankart arthroscopique.",
    },
  ],
  references: [
    { id: 1, text: "Yamamoto N, Itoi E, et al. Contact between the glenoid and the humeral head in abduction, external rotation, and horizontal extension: a new concept of glenoid track. JSES. 2007;16(5):649-56.", pubmed: "17582789" },
    { id: 2, text: "Aswad R, et al. Revision of Latarjet by Eden-Hybinette surgical technique. Orthop Traumatol Surg Res. 2018." },
  ],
};
